export const loadFromLocalStorage = (localStorageKey: string) => {
  return JSON.parse(localStorage.getItem(localStorageKey) || "null");
};
